import React from "react";
import Footer from "../Footer";
import Header from "../Header";
import { useTranslation } from "react-i18next";
import { Button, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { mobilePageContext } from "/src/App";
import { useContext } from "react";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import LinkPhoneNumber from "../../LinkPhoneNumber";
import { LOCALES } from "common/constants";
import { getSchemaMarkup } from "common/FunctionUtils";

export const SidebarWorkingConditions = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("starta-eget-foretag-eller-fakturera-som-privatperson");
  const mobilepageContext = useContext(mobilePageContext);
  const navigate = useNavigate();
  const location = useLocation();

  const { t } = useTranslation();

  const user = useSelector((state) => state.auth.user);
  const working_cndtns = `${blobURL}/working_conditions.png`;
  let language = localStorage.getItem("i18nextLng");
  const businessStructure = `${blobURL}/business-structure.gif`;
  const consultantGIF = `${blobURL}/consultant.gif`;
  const invoicingGIF = `${blobURL}/invoicing.gif`;
  const partnershipGIF = `${blobURL}/partnership.gif`;
  const startBusinessGIF = `${blobURL}/start-business.gif`;
  const workingConditionsGIF = `${blobURL}/working-conditions.gif`;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Helmet>
        {schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        <title>
          {t(
            "Start your own business to invoice or invoice as an individual | Invozio"
          )}
        </title>
        <meta
          name="description"
          content={t(
            "We provide clarity on what suits you for invoicing, whether it should be done through your own company or as an individual through Invozio at the low fee of 1.9%. Read more here…"
          )}
        />
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/start-your-own-business-or-invoice-as-a-private-person"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/starta-eget-foretag-eller-fakturera-som-privatperson"
          />
        )}
      </Helmet>
      {mobilepageContext === false &&
      location?.pathname === "/mobile_goodworking_conditions" ? (
        ""
      ) : (
        <Header />
      )}

      <Container className="p-0">
        <div className="insurances_wrapup Good-working-conditions new_desgn_insurance new_margin_header p-0">
          <section className="insurns_wrap mv">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="security_fntw">
                    <h1 className="security_about text-uppercase mb-0">
                      {t("Working Conditions")}
                    </h1>
                    <h3 className="fnt_family">
                      {t(
                        "What are good working conditions in today's labor market?"
                      )}
                    </h3>
                    {!user && (
                      <Button
                        variant=""
                        className="mt-3 new_theme_btn "
                        onClick={() =>
                          navigate(
                            language === LOCALES.EN_US
                              ? `/emailregister?lang=${LOCALES.EN_US}`
                              : `/e-postregister?lang=${LOCALES.SV_SE}`
                          )
                        }
                      >
                        {t("Create Free Account")}
                      </Button>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="text-right">
                    <div className="image_wrap">
                      <img
                        src={working_cndtns}
                        alt="working-condition"
                        className="image-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="newdesign">
            <div className="container p-0">
              <div className="without_background">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <img
                      src={workingConditionsGIF}
                      alt="logo"
                      className="imganimate"
                      loading="lazy"
                    />
                    <div>
                      <h5>{t("Working Conditions")}</h5>
                      <p>
                        {t(
                          "Our organization is passionate about promoting and supporting people's creativity and ability to create. We believe that each individual has unique talents and potential that can contribute to enriching both their own lives and society as a whole. Regardless of what conditions you have, what talent you possess or what potential you carry, we are here to meet you on your journey."
                        )}
                      </p>
                      <p className="mt-2">
                        {t(
                          "We understand that each person is unique and that individually tailored support is required to unlock their full potential. Therefore, we strive to create a safe and inclusive environment where you can feel seen, heard and understood. We want to equip you with the tools, knowledge and resources needed to create a successful and meaningful career."
                        )}
                      </p>
                      <p className="mt-2">
                        {t(
                          "Our goal is to offer you opportunities and create the conditions for an excellent working life that promotes well-being and personal development. We'll be there every step of the way, whether it's identifying and developing your talents, finding the right career path, or overcoming challenges that may arise along the way."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="business first">
            <div className="container">
              <div className="business-content">
                <h1 className="heading_edit">
                  {t(
                    "Start your own business to invoice or invoice as an individual"
                  )}
                </h1>
                <p>
                  {t(
                    "Starting your own business or invoicing without having your own business are two options that can be appealing to many. However, it is important to carefully consider which business form best suits your needs and goals. We will explore the different business forms and the advantages as well as disadvantages of each option."
                  )}
                </p>
              </div>
            </div>
          </section>

          <section className="business second">
            <div className="container">
              <div className="business-content">
                <h2 className="heading_edit">
                  {t("Understanding different business forms")}
                </h2>
                <p>
                  {t(
                    "Understanding the different business forms is the key to making an informed decision about which one suits you best. Here is an overview of the three most common business forms: sole proprietorship, limited company (corporation), and general partnership."
                  )}
                </p>
              </div>
            </div>
          </section>

          <section className="business third">
            <div className="container">
              <div className="business-content">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <img
                      src={invoicingGIF}
                      alt="logo"
                      className="imganimateright"
                      loading="lazy"
                    />
                    <div>
                      <h3 className="heading_edit">
                        {t("Invoicing with a sole proprietorship")}
                      </h3>
                      <p>
                        {t(
                          "A sole proprietorship is the simplest and most common business form in Sweden. Here, you run the business yourself and are personally responsible for the company's finances. One of the advantages of a sole proprietorship is that it is relatively easy to start, and there is no requirement for initial capital. However, the downside is that as the owner, you have unlimited personal liability for the company's debts."
                        )}
                      </p>

                      <p>
                        {t(
                          "A sole proprietorship can be a suitable business form for those who want to start a smaller operation, such as being a self-employed consultant or a freelance photographer. By running a sole proprietorship, you have full control over the business and can make all decisions independently. It can also be advantageous if you want a quick and straightforward start, as there are no requirements to register with the Swedish Companies Registration Office (Bolagsverket) or to have any share capital."
                        )}
                      </p>

                      <p>
                        {t(
                          "A disadvantage of a sole proprietorship is, however, that as the owner, you have personal liability for the company's debts. This means that if the company faces financial difficulties and cannot pay its debts, your personal assets may be at risk. It is therefore important to be aware of the risks and to have a well-thought-out business plan and financial strategy."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="business fourth">
            <div className="container">
              <div className="business-content">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <img
                      src={partnershipGIF}
                      alt="logo"
                      className="imganimate"
                      loading="lazy"
                    />
                    <div>
                      <h3 className="heading_edit">
                        {t("Partnership for two or more individuals")}
                      </h3>
                      <p>
                        {t(
                          "A partnership is a business form where two or more individuals operate the business together. Similar to a sole proprietorship, the owners are personally responsible for the company's debts. An advantage of a partnership is that it is a flexible business form, and there are no requirements for initial capital. The downside is that, as an owner, you have personal liability for the company's debts, just like in a sole proprietorship."
                        )}
                      </p>

                      <p>
                        {t(
                          "A partnership can be a suitable business form if you want to start a business together with one or more partners. By operating a partnership, you can share responsibilities and workload while also benefiting from each other's skills and resources. It can be advantageous if you plan to operate in sectors such as the restaurant industry, retail, or creative industries where collaboration and shared responsibility can be beneficial."
                        )}
                      </p>

                      <p>
                        {t(
                          "A disadvantage of a partnership is that, as the owner, you have personal liability for the company's debts. This means that if the company faces financial difficulties and cannot pay its debts, your personal assets may be at risk. It is therefore important to have trust in your partners and clear agreements and rules on how to handle financial matters and potential conflicts."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="business fifth">
            <div className="container">
              <div className="business-content">
                <h3 className="heading_edit">
                  {t("A limited company provides sufficient protection")}
                </h3>
                <p>
                  {t(
                    "A limited company is a separate legal entity, and the owners have limited liability for the company's debts. This means that your personal capital is not at risk if the company goes bankrupt. One of the advantages of operating a limited company is also that it provides a more professional image and can facilitate collaboration with other businesses. The downside is that there are certain requirements and regulations that must be followed, such as the requirement to have a share capital and to adhere to specific accounting and reporting standards."
                  )}
                </p>

                <p>
                  {t(
                    "A limited company can be a suitable business form if you plan to start a larger operation or if you want to involve multiple stakeholders. By operating a limited company, you can divide ownership into shares and attract investors or collaborative partners. It can also be advantageous if you aim to grow and expand the business in the future, as it is easier to secure external financing and hire employees in a limited company."
                  )}
                </p>

                <p>
                  {t(
                    "A disadvantage of a limited company is that there are certain requirements and regulations that must be followed. For example, you need to have a share capital at the start of the company, and you must adhere to specific accounting and reporting standards. It can be more administrative and costly compared to operating a sole proprietorship. Therefore, it is important to be aware of these requirements and have a good understanding of the company's finances and legal obligations."
                  )}
                </p>
              </div>
            </div>
          </section>

          <section className="business sixth">
            <div className="container">
              <div className="business-content">
                <h2 className="heading_edit">
                  {t(
                    "Invoicing without a company - for consultants and freelancers"
                  )}
                </h2>
                <p>
                  {t("Invoicing without having your own company")}
                  <Link
                    style={{ textDecoration: "underline" }}
                    to="/"
                    className="heading_edit"
                  >
                    {" "}
                    <u>invozio.com</u>{" "}
                  </Link>
                  {t(
                    "can be an attractive opportunity for those who want to work as consultants or freelancers without the need to start and manage their own business"
                  )}{" "}
                </p>
                <div className="row align-items-center">
                  <div className="col-md-12 p-0">
                    <img
                      src={consultantGIF}
                      alt="logo"
                      className="imganimateright"
                      loading="lazy"
                    />
                    <div>
                      <h3 className="heading_edit">
                        {t("What does it mean to invoice without a company?")}
                      </h3>
                      <p>
                        {t(
                          "When you invoice without having your own company, it means that you provide services as an individual and send invoices directly to your clients. You don't need to register a company or adhere to business-related rules and requirements. It can be a simple way to start as a freelancer without making significant investments or taking on administrative obligations."
                        )}
                      </p>

                      <p>
                        {t(
                          "If you choose to invoice without having a company, it is important that you are aware of the laws and regulations governing the provision of services as an individual. Therefore, it's advisable to consult a legal expert at Invozio to ensure that you are following all necessary rules and have a proper invoicing process"
                        )}
                      </p>

                      <h3 className="heading_edit">
                        {t("Pros and cons of invoicing without a company")}
                      </h3>

                      <p>
                        {t(
                          "A significant advantage of invoicing without having a company"
                        )}
                        <Link
                          style={{ textDecoration: "underline" }}
                          to="/"
                          className="heading_edit"
                        >
                          {" "}
                          <u>invozio.com</u>{" "}
                        </Link>
                        {t(
                          "is that it is easier and quicker to get started. You also avoid certain administrative tasks associated with running your own business, such as accounting and bookkeeping. It can be appealing to focus more on the actual work and less on business administration"
                        )}{" "}
                      </p>

                      <p>
                        {t(
                          "Previously, a disadvantage of invoicing without having a company was the lack of insurance protection for your personal capital. Now, on the other hand, you have comprehensive insurance coverage in case anything goes wrong. If you were to become involved in a dispute with a client or face legal action, your personal assets could be at risk. However, nowadays, all reputable entities offer protection against this"
                        )}
                      </p>

                      <p>
                        {t(
                          "Another disadvantage is that you are limited when it comes to growing and expanding your business. Without a company, it may be more challenging to secure larger and more complex projects, and you may also find it harder to attract serious and established clients."
                        )}
                      </p>

                      <p>
                        {t(
                          "It is important to carefully consider both the advantages and disadvantages before deciding to invoice without having a company. It may be a good solution for some, but it is not the right choice for everyone. Take the time to conduct a thorough analysis and consider all aspects before making a decision. For consultants and freelancers, it is a cost-effective and time-saving alternative. However, for those planning expansion, hiring more employees, and seeking capital, a limited company is better suited."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="business seventh">
            <div className="container">
              <div className="business-content">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <img
                      src={businessStructure}
                      alt="logo"
                      className="imganimate"
                      loading="lazy"
                    />
                    <div>
                      <h2 className="heading_edit">
                        {t("How to choose the right business structure")}
                      </h2>
                      <p>
                        {t(
                          "Choosing the right business structure is an important process that requires assessing your business needs and taking various factors into account. Here are some things to consider when selecting a business structure."
                        )}
                      </p>

                      <h3 className="heading_edit">
                        {t("Assessing your business needs")}
                      </h3>

                      <p>
                        {t(
                          "To choose the right business structure, it is important to assess your business needs and goals. What type of business do you plan to operate? In which industry are you active? What is your turnover, and how many employees do you plan to have? These factors can help determine which business structure is best suited for you."
                        )}
                      </p>

                      <p>
                        {t(
                          "For example, if you are planning to start a restaurant business, it may be advantageous to choose a limited company structure. This is because limited companies can be more suitable for larger businesses with multiple owners and higher turnover. On the other hand, if you plan to operate a smaller consulting business where you are the sole owner and have lower turnover, a sole proprietorship may be a more suitable option"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="business eigth">
            <div className="container">
              <div className="business-content">
                <h3 className="heading_edit">
                  {t("Considering your personal risk tolerance")}
                </h3>
                <p>
                  {t(
                    "Another important factor to consider is your personal risk tolerance. How much are you willing to risk? If you are willing to risk your personal capital and have confidence in your ability to run a successful business, a sole proprietorship may be an option for you. If you are more risk-averse and want to protect your personal capital, a limited company may be a better alternative"
                  )}
                </p>

                <p>
                  {t(
                    "It's important to remember that a sole proprietorship entails personal liability for the company's debts and obligations. This means that if the company encounters financial difficulties, your personal assets may be at risk. On the other hand, a limited company provides limited liability for the owners, meaning that your personal assets generally cannot be affected if the company goes bankrupt. This is applicable if you have followed the rules for limited companies, including maintaining at least half of the share capital in the company. Otherwise, you may become personally liable"
                  )}
                </p>

                <h3 className="heading_edit">
                  {t("Consider tax consequences")}
                </h3>
                <p>
                  {t(
                    "The tax consequences are also important to consider when choosing a business structure. Each business form has different tax rules and rates that can impact your taxation. It may be wise to consult a tax expert to gain a better understanding of which business structure may be most advantageous for you from a tax perspective."
                  )}
                </p>

                <p>
                  {t(
                    "For example, limited companies may have advantageous tax arrangements that allow owners to receive salary and dividends in a way that minimizes the tax burden. On the other hand, sole proprietorships may have simpler tax arrangements where the owner is taxed on the company's profit as personal income. It is important to carefully consider these tax consequences and how they can affect your overall taxation. This is more challenging to navigate when invoicing without a company."
                  )}
                </p>
              </div>
            </div>
          </section>

          <section className="business ninth">
            <div className="container">
              <div className="business-content">
                <h2 className="heading_edit">
                  {t("Steps to start your own business")}
                </h2>
                <p>
                  {t(
                    "Once you have decided on the business structure that suits you best, it's time to take the step and start your own business. Here are some important steps you need to take"
                  )}
                </p>
                <div className="row align-items-center">
                  <div className="col-md-12 p-0">
                    <img
                      src={startBusinessGIF}
                      alt="logo"
                      className="imganimateright"
                      loading="lazy"
                    />
                    <div>
                      <h3 className="heading_edit">
                        {t("Creating a business plan")}
                      </h3>
                      <p>
                        {t(
                          "A business plan is a strategic document that outlines your business idea, goals, and how you plan to achieve them. It is important to create a clear and concise business plan that can serve as a guide for your operations."
                        )}
                      </p>

                      <p>
                        {t(
                          "A well-crafted business plan can help you clearly define your target audience, competitors, and marketing strategies. By carefully analyzing the market and identifying your competitive advantages, you can create a sustainable business model that can contribute to your success."
                        )}
                      </p>

                      <h3 className="heading_edit">
                        {t("Registering your business")}
                      </h3>
                      <p>
                        {t(
                          "To operate your business, you must register it with the Swedish Companies Registration Office (Bolagsverket) or the Swedish Tax Agency (Skatteverket), depending on the chosen business structure. You need to fill out the necessary forms and pay any applicable fees to get your business registered"
                        )}
                      </p>

                      <p>
                        {t(
                          "It is important to be aware of the various legal and administrative requirements involved in registering your business. Seeking professional advice can be advantageous to ensure that you meet all requirements and that your business is legally established"
                        )}
                      </p>

                      <h3 className="heading_edit">
                        {t("Financing your business")}
                      </h3>
                      <p>
                        {t(
                          "Financing your business can be a challenge, especially in the beginning when you have no income. You may need to seek financial support from investors, banks, or other financial institutions. You can also consider using your own savings or taking a loan to fund your business."
                        )}
                      </p>

                      <p>
                        {t(
                          "It is important to carefully plan and budget for your financial needs. By creating a realistic financial plan, you can assess how much capital you require and which financing options are most suitable for your situation"
                        )}
                      </p>

                      <p>
                        {t(
                          "After reading this guide, we hope you have gained a better understanding of which business structure suits you best. It is important to carefully consider your needs and goals before taking the step to start your own business or invoice without having your own company via Invozio at the market's most favorable conditions with a 1.9 percent fee."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="business tenth">
            <div className="container">
              <div className="business-content">
                <Button
                  className="mt-4 mb-2 create-account filled home_create_account"
                  onClick={() => {
                    navigate(
                      language === LOCALES.EN_US
                        ? `/emailregister?lang=${LOCALES.EN_US}`
                        : `/e-postregister?lang=${LOCALES.SV_SE}`
                    );
                    sessionStorage.setItem("accountType", 1);
                  }}
                >
                  {t("Sign up and start invoicing at the market's best prices")}
                </Button>
                <p className="mt-0">
                  {t("For more information, email us at")}
                  <a href="mailto:support@invozio.com" className="email">
                    {" "}
                    support@invozio.com{" "}
                  </a>
                  {t("or call us at")}{" "}
                  <LinkPhoneNumber />
                </p>
              </div>
            </div>
          </section>
        </div>
      </Container>

      {mobilepageContext === false &&
      location?.pathname === "/mobile_goodworking_conditions" ? (
        ""
      ) : (
        <div className="working">
          <Footer dashboardFooter={dashboardFooter} />
        </div>
      )}
    </>
  );
};
